// extracted by mini-css-extract-plugin
export default {"root":"Education_root__67T+k","inner":"Education_inner__-l+CJ","onlyMobile":"Education_onlyMobile__nI0-Z"};